import React from 'react';
import LandingHelmet from './LandingHelmet';
import PageHeader from 'components/Pages/PageHeader';
import Hero from './Hero';
import Support from './Support';
import CertifiedOnce from './CertifiedOnce';
import Global from './Global';
import Start from './Start';
import Help from './Help';
import HowItWorks from './HowItWorks';

import {PublicLayout} from 'components/Layouts';

import LandingFinalCta from './LandingFinalCta';
import LandingNonCompliant from './LandingNonCompliant';
import LandingStakeholder from './LandingStakeholder';
import Section from 'views/services/Section';

function Index() {
  return (
    <>
      <PublicLayout header={false}>
        <LandingHelmet />
        <PageHeader logoSize="lg" fluid={false} fixed={false} sticky dark />
        <Hero />
        <Help />
        <Support />
        <CertifiedOnce />
        <Global />
        <LandingFinalCta />
        <HowItWorks />
        <LandingNonCompliant />
        <Section className="py-0">
          <hr className="m-0" />
        </Section>
        <LandingStakeholder />
        <Start />
      </PublicLayout>
    </>
  );
}

export default Index;
